module.exports = __webpack_public_path__ + "static/second_mockup_wyborek-997fc82ea0a5f8354e606ba661a24810.png";